import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const tryScroll = (attempts = 0) => {
      const el = document.getElementById('pricing-early');
      if (el) {
        // Force content-visibility to render before scrolling
        el.style.contentVisibility = 'visible';
        requestAnimationFrame(() => {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      } else if (attempts < 20) {
        setTimeout(() => tryScroll(attempts + 1), 100);
      }
    };
    tryScroll();
  };
  return <div className="pt-24 pb-16 px-4 max-w-4xl mx-auto text-center" data-id="element-140">
      <div className="inline-block bg-brand-bgAlt border border-brand-subtitle/20 rounded-full px-4 py-1.5 font-heading font-semibold text-brand-title mb-8 text-[12px] tracking-wide" data-id="element-141">
        🧴 EL AUDITOR DE SKINCARE™
      </div>

      <h1 className="font-display text-brand-title md:text-7xl font-extrabold tracking-tight mb-6 text-[48px] leading-tight" data-id="element-142">
        Sana tu piel (de verdad) En 7 días
      </h1>

      <div className="my-10 md:my-14 flex justify-center" style={{
      maxWidth: '665px',
      margin: '2.5rem auto 3.5rem'
    }} data-id="element-143">
        <img src="https://cdn.magicpatterns.com/uploads/xmWWXLxxKZHbU6tdCBbPSt/mockup_(1).webp" alt="El Auditor de Skincare™ — 5 Tomos + 3 Bonos" width={665} height={665} fetchPriority="high" className="w-full max-w-xl md:max-w-2xl" data-id="element-144" />
      </div>

      <div className="space-y-2 mb-8 mt-10" data-id="element-145">
        <p className="font-heading md:text-2xl font-semibold text-brand-subtitle text-[18px] italic" data-id="element-146">
          "Tu piel no necesita más productos. Necesita la verdad."
        </p>
      </div>

      <p className="font-body text-brand-text max-w-2xl mx-auto mb-10 text-[16px] leading-relaxed" data-id="element-147">
        El único sistema científico que en 7 días: 📍Detecta qué está
        destruyendo tu piel. 📍Elimina los productos que te sabotean. 📍 Te
        enseña a lograr la piel que buscas sin gastar un euro más.
      </p>

      <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-148">
        <span className="bg-white border border-neutral-200 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2 text-brand-text shadow-sm" data-id="element-149">
          📄 100% PDF
        </span>
        <span className="bg-white border border-neutral-200 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2 text-brand-text shadow-sm" data-id="element-150">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-white border border-neutral-200 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2 text-brand-text shadow-sm" data-id="element-151">
          🌍 Para mujeres en España
        </span>
      </div>

      <button onClick={scrollToPricing} className="font-heading bg-brand-cta hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-full transition-transform hover:scale-105 active:scale-95 shadow-[0_10px_40px_rgba(123,47,190,0.3)] w-full md:w-auto mb-8" data-id="element-152">
        🧴 → QUIERO MI AUDITOR AHORA
      </button>

      <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-subtitle font-medium" data-id="element-153">
        <span className="flex items-center gap-2" data-id="element-154">
          🛡️ Garantía 7 días sin preguntas
        </span>
        <span className="flex items-center gap-2" data-id="element-155">🔒 Pago 100% seguro</span>
        <span className="flex items-center gap-2" data-id="element-156">💳 Pago en euros</span>
      </div>
    </div>;
}